import { render } from "./BackNavigationButton.vue?vue&type=template&id=0a07c056&scoped=true"
import script from "./BackNavigationButton.vue?vue&type=script&lang=js"
export * from "./BackNavigationButton.vue?vue&type=script&lang=js"

import "./BackNavigationButton.vue?vue&type=style&index=0&id=0a07c056&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a07c056"]])

export default __exports__